import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-t', 'LetterT', [["path",{"d":"M6 4l12 0"}],["path",{"d":"M12 4l0 16"}]]);